<div class="automation-date created-date">
  {{ automationGroup?.created | epoch : dateTimeFormat }}
</div>

<div class="automation-date triggered-date">
  {{ automationGroup?.lastupdate | epoch : dateTimeFormat }}
</div>
<div class="automation-actions d-flex justify-content-end">
  <ng-container *ngIf="automationGroup">
    <ng-content select="[actions]"></ng-content>
    <button
      class="btn btn-light-info btn-sm"
      (click)="onEditTask()"
      matTooltip="Edit Task"
      i18n-matTooltip
      *ngIf="task"
    >
      <i class="cs-icon cs-icon-board-check text-lg"></i>
    </button>

    <button
      class="btn btn-light-info btn-sm"
      (click)="onEditTemplate()"
      matTooltip="Edit Template"
      i18n-matTooltip
      *ngIf="template"
    >
      <i class="far fa-file-alt text-lg"></i>
    </button>

    <button
      class="btn btn-light-info btn-sm"
      (click)="onEditExpense()"
      matTooltip="Edit Expense"
      i18n-matTooltip
      *ngIf="expense"
    >
      <i class="cs-icon cs-icon-wallet text-lg"></i>
    </button>

    <button
      class="btn btn-light-info btn-sm"
      (click)="onEditReview()"
      matTooltip="Edit Review"
      i18n-matTooltip
      *ngIf="isSendReview"
    >
      <i class="cs-icon cs-icon-chat-star text-lg"></i>
    </button>

    <button
      class="btn btn-light-info"
      (click)="onEditIncident()"
      matTooltip="Edit Incident"
      i18n-matTooltip
      *ngIf="incident"
    >
      <i class="cs-icon cs-icon-building-incident"></i>
    </button>

    <button class="btn btn-light-primary btn-sm" (click)="onLogs()" i18n-matTooltip matTooltip="View automation logs">
      <i class="cs-icon cs-icon-calendar-clock text-lg"></i>
    </button>
  </ng-container>

  <button
    class="btn btn-light-primary btn-sm"
    (click)="onConfig()"
    i18n-matTooltip
    matTooltip="Configure this automation"
  >
    <i class="cs-icon cs-icon-cog text-lg"></i>
  </button>
  <button
    class="btn btn-light-danger btn-sm"
    (click)="onDelete()"
    matTooltip="Delete this automation"
    i18n-matTooltip
    *ngIf="automationGroup"
  >
    <i class="cs-icon cs-icon-trash text-lg"></i>
  </button>
</div>
